/////////////////////////////////////////////////////////////////////////////////////////////////////////
// 화일명 : index.tsx
// 설명 : 프론트앤드 진입점
//  - 프론트앤드로 들어오는 모든 요청을 처리합니다.
// 최종수정일 : 2025-08-12
/////////////////////////////////////////////////////////////////////////////////////////////////////////
import ReactDOM from 'react-dom/client';

////////////////////////////////////////////////////////////////////////////////////////////////////////////
// 사용자정의 모듈
////////////////////////////////////////////////////////////////////////////////////////////////////////////
import App from './App';
import './styles/tokensV1.css'; // ERP형 색 토큰(V1) - 다른 css보다 먼저 로드
import './styles/index.css';
import reportWebVitals from './reportWebVitals';
import './utils/axiosSetup'; // axios 전역 인터셉터(토큰 자동첨부 + 401 처리) 등록
import { loadMainframeTheme } from './styles/mainframeTheme'; // 메인프레임 테마(버전) CSS 로더

// 2026-09-19: "ResizeObserver loop completed with undelivered notifications"는 ResizeObserver 콜백이
// 같은 관찰 주기 안에서 또 다른 리사이즈를 동기적으로 유발할 때(에디터에 큰 이미지를 붙여넣어 레이아웃이
// 갑자기 바뀌는 경우 등 - AgGrid/자체 스크롤버튼 훅 등 여러 곳에서 ResizeObserver를 씀) 브라우저가 던지는
// 경고성 에러임. CRA 개발서버의 오류 오버레이가 이 이벤트를 우리 index.tsx 코드보다 먼저 구독해버려서
// window.addEventListener('error', ...)+stopImmediatePropagation으로는 못 막았음(등록 순서상 이미 늦음).
// 그래서 근본 원인 자체를 없앰: 전역 ResizeObserver를 감싸서 콜백을 requestAnimationFrame으로 한 틱
// 미루면, 콜백이 같은 관찰 주기 안에서 동기적으로 재귀 리사이즈를 못 일으키므로 애초에 브라우저가
// "루프"로 인식할 조건 자체가 생기지 않음(AgGrid 등 다른 라이브러리가 만드는 ResizeObserver도 전부
// 이 래퍼를 거치게 되므로 앱 전역에 적용됨).
if (typeof window !== 'undefined' && 'ResizeObserver' in window) {
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends OriginalResizeObserver {
    constructor(callback: ResizeObserverCallback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

// 적용중 메인프레임 테마(V0/V1 ...)의 CSS 묶음을 먼저 로드한 뒤 화면을 그림(로드 전 스타일 없는 화면이 깜빡이지 않도록)
loadMainframeTheme().finally(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <App />
  );
});


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
